import { Spinner as _Spinner, SpinnerProps as _SpinnerProps } from "reactstrap";

export const Spinner = _Spinner;
export type SpinnerProps = _SpinnerProps;
